<div class="modal__content--lightbox {{content_class}} js-modal__content">
  <div class="modal__header__close--lightbox">
    <button type="button" class="btn btn-overlay" {{#unless prevent_close_feedback}}data-close="true" {{/unless}}
      data-dismiss="modal" {{#unless sr_close_caption}}aria-label="{{t 'closeModal'}}" {{/unless}}>
      {{>icon uuid=cid prefix="far" name="fa-xmark-large" size="fa-lg"}}
      <span
        class="screen-reader-content">{{#if sr_close_caption}}{{t sr_close_caption}}{{else}}{{t close_caption}}{{/if}}</span>
    </button>
  </div>
  <div class="modal__body--lightbox {{body_class}}">
    {{#if blocks}}
    <div data-region="{{cid}}-modal-blocks"></div>
    {{/if}}
  </div>
  {{f 'editblock' '' cid forge_path 'modal'}}
</div>
